import React from "react"
import { Table } from "react-bootstrap"

import Booking from "@/dashboard/models/Booking"

import BookingRow from "./BookingRow"

const BookingTable = ({ bookings }: { bookings: Array<Booking> }): JSX.Element => {
  let tableClassName = "align-items-center table-flush"

  if (bookings.length > 0) {
    // bottom padding
    tableClassName += " mb-3"
  }

  return (
    <Table size="sm" className={tableClassName}>
      <thead className="thead-light">
        <tr>
          <th scope="col">Reference</th>
          <th scope="col">Charged Guest</th>
          <th scope="col" className="text-right">
            Guests
          </th>
          <th scope="col" className="text-right">
            Net
          </th>
          <th scope="col" className="text-right">
            Retail
          </th>
          <th scope="col" />
        </tr>
      </thead>
      <tbody>
        {bookings.map((booking) => (
          <BookingRow booking={booking} key={booking.reference} />
        ))}
      </tbody>
    </Table>
  )
}

export default BookingTable
